import { weekDaysShort } from '@utils';
import React from 'react';

export const Header = () => {
  return (
    <div className="weekDays">
      {weekDaysShort.map((day: string) => (
        <div className="day" key={day}>
          {day}
        </div>
      ))}
    </div>
  );
};